import { gql } from '@apollo/client';

export interface TriggerPickupHubDataFixResponse {
  triggerPickupHubDataFix: {
    taskId: string;
    pendingCount: number;
    alreadyRunning: boolean;
    description: string;
  };
}

export interface TriggerPickupHubDataFixVariables {
  input: {
    dryRun: boolean;
    batchSize?: number | null;
    delayMs?: number | null;
  };
}

export const TRIGGER_PICKUP_HUB_DATA_FIX = gql`
  mutation TriggerPickupHubDataFix($input: PickupHubDataFixInput!) {
    triggerPickupHubDataFix(input: $input) {
      taskId
      pendingCount
      alreadyRunning
      description
    }
  }
`;

export interface PickupHubDataFixSummaryResponse {
  pickupHubDataFixSummary: {
    pendingCount: number;
    fixedCount: number;
    skippedCount: number;
  };
}

export const PICKUP_HUB_DATA_FIX_SUMMARY = gql`
  query PickupHubDataFixSummary {
    pickupHubDataFixSummary {
      pendingCount
      fixedCount
      skippedCount
    }
  }
`;
